export class CountryPhoneNumberFormats {
    public static formats: CountryPhoneNumberFormat[] = [
        { countryCode: 'USA', phoneNumberMaskFormat: '(000) 000-0000' },
        { countryCode: 'CAN', phoneNumberMaskFormat: '(000) 000-0000' },
        { countryCode: 'GBR', phoneNumberMaskFormat: '00000 000000000000000' },
        { countryCode: 'GGY', phoneNumberMaskFormat: '00000 000000000000000' },
        { countryCode: 'IMN', phoneNumberMaskFormat: '00000 000000000000000' },
        { countryCode: 'JEY', phoneNumberMaskFormat: '00000 000000000000000' },
        { countryCode: 'IRL', phoneNumberMaskFormat: '00000 000000' },
        { countryCode: 'ILN', phoneNumberMaskFormat: '00000 000000' },
        { countryCode: 'ARE', phoneNumberMaskFormat: '000000000000000' },
        { countryCode: 'SAU', phoneNumberMaskFormat: '000000000000000' },
        { countryCode: 'QAT', phoneNumberMaskFormat: '999999999999999' },
        { countryCode: 'KWT', phoneNumberMaskFormat: '999999999999999' },
        { countryCode: 'BHR', phoneNumberMaskFormat: '999999999999999' },
        { countryCode: 'OMN', phoneNumberMaskFormat: '999999999999999' },
        { countryCode: 'AUS', phoneNumberMaskFormat: '9999999999' },
        { countryCode: 'SWE', phoneNumberMaskFormat: '00000000000000000000' },
        { countryCode: 'NOR', phoneNumberMaskFormat: '00000000000000000000' },
        { countryCode: 'FIN', phoneNumberMaskFormat: '00000000000000000000' },
        { countryCode: 'DNK', phoneNumberMaskFormat: '00000000000000000000' },
        { countryCode: 'BEL', phoneNumberMaskFormat: '0000000000' },
        { countryCode: 'LUX', phoneNumberMaskFormat: '0000000000' },
        { countryCode: 'NLD', phoneNumberMaskFormat: '0000000000' },
        { countryCode: 'NZL', phoneNumberMaskFormat: '999999999999999' },
        { countryCode: 'COK', phoneNumberMaskFormat: '000000000000000'},
        { countryCode: 'FJI', phoneNumberMaskFormat: '000000000000000'},
        { countryCode: 'NCL', phoneNumberMaskFormat: '000000000000000'},
        { countryCode: 'PNG', phoneNumberMaskFormat: '000000000000000'},
        { countryCode: 'SLB', phoneNumberMaskFormat: '000000000000000'},
        { countryCode: 'VUT', phoneNumberMaskFormat: '000000000000000'},
        { countryCode: 'POL', phoneNumberMaskFormat: '000000000000000'},
        { countryCode: 'DEU', phoneNumberMaskFormat: '00000000000000000000' },
        { countryCode: 'AUT', phoneNumberMaskFormat: '00000000000000000000' },
        { countryCode: 'MKD', phoneNumberMaskFormat: '000000000'},
        { countryCode: 'BGR', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'CHE', phoneNumberMaskFormat: '00000000000000000000' },
        { countryCode: 'SEN', phoneNumberMaskFormat: '000000000000000'},
        { countryCode: 'CPV', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'GMB', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'GIN', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'GNB', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'MLI', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'MRT', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'ZAF', phoneNumberMaskFormat: '0000000000000'},
        { countryCode: 'BWA', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'LSO', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'MOZ', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'NAM', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'SWZ', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'ZWE', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'NGA', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'TCD', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'GNQ', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'ERI', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'CAF', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'ISL', phoneNumberMaskFormat: '000 0000' },
        { countryCode: 'TZA', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'BDI', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'MWI', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'ZMB', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'CIV', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'LIE', phoneNumberMaskFormat: '00000000000000000000' },
        { countryCode: 'COD', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'GHA', phoneNumberMaskFormat: '0000000000'},
        { countryCode: 'COG', phoneNumberMaskFormat: '0000000000'},
    ];
}

interface CountryPhoneNumberFormat {
    countryCode: string;
    phoneNumberMaskFormat: string;
}



// WEBPACK FOOTER //
// ./src/app/common/constants/country-phonenumber-format.constants.ts